

















































import Vue from "vue";
import { TableLayout } from "@/layouts";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import Edit from "@/components/SpaceMembers/Edit.vue";
import Invite from "@/components/SpaceMembers/Invite.vue";

const SpaceMembersHeaders: Header[] = [
  { title: "用户名", key: "userName" },
  { title: "创建时间", key: "createTime", minWidth: 180 },
  { title: "更新时间", key: "updateTime", minWidth: 180 },
  { title: "用户角色", key: "roleDesc" },
  { title: "邀请人", key: "createBy" },
  { title: "操作", key: "", width: 100 }
];
export default Vue.extend({
  name: "SpaceMembers",
  components: { TableLayout, Edit, Invite },
  props: { tenantId: { type: String } },
  data() {
    return {
      SpaceMembersHeaders
    };
  },
  computed: {
    ...mapState("SpaceMembers", [
      "inviteList",
      "pages",
      "pageNum",
      "total",
      "filterValue",
      "hasNext"
    ]),
    ...mapGetters("SpaceMembers", ["tableData"])
  },
  mounted() {
    this.getData(this.tenantId);
    this.invite(this.tenantId);
  },
  beforeDestroy() {
    this.ClearStateMutation();
  },
  methods: {
    ...mapActions("SpaceMembers", [
      "invite",
      "getData",
      "delete",
      "search",
      "turnPage"
    ]),
    ...mapMutations("SpaceMembers", ["ClearStateMutation"]),
    inviteDialog() {
      (this.$refs.invite as any)?.show(this.inviteList);
    },
    edit(data: any) {
      (this.$refs.edit as any)?.show(data);
    },
    del(userId: string, name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.delete({ userId: userId, tenantId: this.tenantId });
      });
    },
    searchUser(value: string) {
      this.search({ value: value, append: this.tenantId });
    }
  }
});
